module.exports = __webpack_public_path__ + "static/media/three-dots-vertical.4e315e88.svg";